import { render, staticRenderFns } from "./CrItemDialog.vue?vue&type=template&id=1700067e"
import script from "./CrItemDialog.vue?vue&type=script&lang=js"
export * from "./CrItemDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports